var script_loaded = !1;

// Swap data-src/data-href into src/href (e.g. quickView.js, predictive-search CSS),
// flip .deferredScript types, then fire the StartAsyncLoading/StartKernelLoading events.
function runDeferredLoad() {
    var i;
    var t = document.getElementsByTagName("script");
    for (i = 0; i < t.length; i++) null !== t[i].getAttribute("data-src") && (t[i].setAttribute("src", t[i].getAttribute("data-src")), delete t[i].dataset.src);
    var e = document.getElementsByTagName("link");
    for (i = 0; i < e.length; i++) null !== e[i].getAttribute("data-href") && (e[i].setAttribute("href", e[i].getAttribute("data-href")), delete e[i].dataset.href);
    Array.prototype.forEach.call(document.getElementsByClassName("deferredScript"), function(s) {
        s.type = "text/javascript";
    });
    setTimeout(function() {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
        document.dispatchEvent(new CustomEvent("StartKernelLoading"))
    }, 400)
}

var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];
var activityListenerOptions = { once: true, passive: true };

function removeActivityListeners() {
    activityEvents.forEach(function(eventName) {
        window.removeEventListener(eventName, loadJSscriptsNow, activityListenerOptions);
    });
}

function loadJSscripts() {
    setTimeout(function() {
        if (!script_loaded) {
            script_loaded = !0;
            removeActivityListeners();
            runDeferredLoad();
        }
    }, 9500);
}

function loadJSscriptsNow() {
    if (!script_loaded) {
        script_loaded = !0;
        removeActivityListeners();
        runDeferredLoad();
    }
}

activityEvents.forEach(function(eventName) {
    window.addEventListener(eventName, loadJSscriptsNow, activityListenerOptions);
});
document.addEventListener("load", loadJSscripts, false);
document.addEventListener("onload", loadJSscripts, false);
if (window.addEventListener != undefined) {
    window.addEventListener("load", loadJSscripts, { once: true });
} else if (window.attachEvent != undefined) {
    window.attachEvent("onload", loadJSscripts);
} else {
    window.onload = loadJSscripts;
}
// optimize.js is loaded async: if the window load event already fired, start the fallback timer now
// (previously the 9.5s fallback was silently skipped in that case).
if (document.readyState === "complete") {
    loadJSscripts();
}
